import { Zap, Database } from "lucide-react";

export const SourceBadge = ({ source, testId }) =>
  source === "override" ? (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-sm border border-amber-500/40 bg-amber-500/15 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-amber-400">
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-70" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber-400" />
      </span>
      <Zap className="h-3 w-3" /> Our stock
    </span>
  ) : (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-sm border border-blue-500/40 bg-blue-500/15 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-blue-400">
      <Database className="h-3 w-3" /> SAP
    </span>
  );

export const StatusBadge = ({ status, testId }) => {
  if (!status) return <span data-testid={testId} className="font-mono text-[10px] text-slate-500">NO FCST</span>;
  const low = status === "low";
  return (
    <span
      data-testid={testId}
      className={`inline-flex rounded-sm border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${
        low ? "border-red-500/40 bg-red-500/15 text-red-400" : "border-emerald-500/40 bg-emerald-500/15 text-emerald-400"
      }`}
    >
      {low ? "Low DOH" : "OK"}
    </span>
  );
};
